import {API_URLS} from '@/const';
import {http} from '@/helper';

export const buyCrypto = {
  placeOrder(query) {
    return http.post(API_URLS.BUY_CRYPTO_PLACE_ORDER, {query});
  },
  getSupportedConfig() {
    return http.get(API_URLS.SUPPORTED_CONFIG, {
      formatter(data) {
        const {fiats, currencies, supportPayWays, channelWeights, transferoCPFCountries} = data;
        fiats.map((fiat) => {
          fiat.text = fiat.fiat;
          fiat.value = fiat.fiat;
          return fiat;
        });
        currencies.map((item) => {
          item.text = item.currency;
          if (item.currency === 'USDT') {
            item.currency = item.currency + '-' + item.name.split('-')[1];
          }
          item.value = item.currency;
          return item;
        });
        supportPayWays.map((payment) => {
          payment.text = payment.displayName;
          payment.value = payment.name;
          return payment;
        });
        return {fiats, currencies, supportPayWays, channelWeights, transferoCPFCountries};
      },
    });
  },
  smartPricing(query) {
    return http.get(API_URLS.SMART_PRICING, {query});
  },
  getSimplexPreOrderInfo(query) {
    return http.get(API_URLS.SIMPLEX_PRE_ORDER_INFO, {query});
  },
  getOrderHistory(query) {
    return http.get(API_URLS.BUY_CRYPTO_ORDER_HISTORY, {query});
  },
  getBuyCryptoConfig(query, isLogin) {
    return http.get(isLogin ? API_URLS.BUY_CRYPTO_CONFIG : API_URLS.PUBLIC_BUY_CRYPTO_CONFIG, {query});
  },
  getBuyCryptoPricing(query, isLogin) {
    return http.get(isLogin ? API_URLS.BUY_CRYPTO_PRICING : API_URLS.PUBLIC_BUY_CRYPTO_PRICING, {query});
  },
  getBuyCryptoBanner(query) {
    return http.get(API_URLS.BUY_CRYPTO_BANNER, {query});
  },
  getUserLocation() {
    return http.get(API_URLS.USER_LOCATION, {});
  },
  getPromotion(query) {
    return http.get(API_URLS.PUBLIC_B2C_BANNER, {query});
  },
  createBankAccount(params) {
    return http.post(API_URLS.FIAT_WITHDRAW_BANK_ACCOUNT_ADD, {params});
  },
  removeBankAccount(query) {
    return http.get(API_URLS.FIAT_WITHDRAW_BANK_ACCOUNT_REMOVE, {query});
  },
  queryBankAccount(query) {
    return http.get(API_URLS.FIAT_WITHDRAW_BANK_ACCOUNT, {query});
  },
  queryBankAccountCountries(query) {
    return http.get(API_URLS.FIAT_WITHDRAW_BANK_COUNTRIES, {query});
  },
  queryBankAccountFields(query) {
    return http.get(API_URLS.FIAT_WITHDRAW_BANK_FIELDS, {query});
  },
};
